<nav class="top-0 z-50 w-full rounded border-gray-200 bg-white px-[80px] py-[25px]">
  <div class="mx-auto flex items-center justify-between">
    <div class="flex">
      <a [routerLink]="routes.PUBLICATIONS" class="flex cursor-pointer items-center">
        <img src="../../../../assets/svg/logoLunaNuevaProperties.svg" class="h-[108px] w-[202px]" alt="Logo" />
      </a>
    </div>
    @if (showOptions()) {
      <div class="flex w-full justify-end">
        <div class="menuMobile flex w-auto items-center justify-between" id="navbar-cta">
          
          <button class="py-2 pl-3 pr-4 font-medium text-cafeLuna" mat-menu-item (click)="openDialogCloseSession()">
            Cerrar sesión
          </button>
        </div>
      </div>
    }
  </div>
</nav>
